export default "__VITE_ASSET__CR$S3xjB__"